module.exports = __webpack_public_path__ + "static/media/03B.38269163.png";